import { clamp, isNumber } from "../utils/primitives";

// import * as React from 'react';
import { InputProps } from "baseui/input";

type THookReturn = {
  showStepControls?: boolean;
  incrementDisabled?: boolean;
  decrementDisabled?: boolean;
  decrement: () => void;
  increment: () => void;
  onInputChange: (event: React.FormEvent<HTMLInputElement>) => void;

  /** Represents progress from min to max as a value from 0 to 1. */
  progress?: number;
};

const useNumberInput = (props: InputProps): THookReturn => {
  const {
    value,
    onChange,
    min,
    max,
    disabled,
    step = 1,
    showStepControls = true,
  } = props;

  const numberValue = Number(value);
  const numberStep = Number(step);
  const decrementDisabled = disabled || numberValue <= min;
  const incrementDisabled = disabled || numberValue >= max;

  const decrement = () => {
    const newValue = isNaN(numberValue) ? 0 : numberValue - numberStep;
    const clampedValue = clamp(min, max, newValue);
    handleChange(clampedValue);
  };

  const increment = () => {
    const newValue = isNaN(numberValue) ? 0 : numberValue + numberStep;
    const clampedValue = clamp(min, max, newValue);
    handleChange(clampedValue);
  };

  // Some of our Inputs use events, some use values. Should we make a standard interface?
  const onInputChange = (event) => {
    const eventValue = event?.currentTarget?.value ?? event;
    handleChange(eventValue);
  };

  const handleChange = (value) => {
    onChange?.(`${value}` as TODO);
  };

  const progress =
    isNumber(min) &&
    isNumber(max) &&
    isNumber(value) &&
    clamp(0, 1, (numberValue - min) / (max - min));

  return {
    showStepControls,
    decrementDisabled,
    incrementDisabled,
    decrement,
    increment,
    onInputChange,
    progress,
  };
};

export { useNumberInput };
